import React, { useEffect } from 'react'
import { useForm } from 'react-hook-form'
import Input from '../Input/Input'
import Style from './AddNote.module.css'

const AddNote = (props) => {
    // مقدار اولیه را مستقیم به useForm می‌دهیم
    const { register, handleSubmit, setValue } = useForm({
        defaultValues: {
            note: props.userNote || ''
        }
    })

    // اگر userNote از بیرون (کامپوننت پدر) تغییر کرد، فقط مقدار فرم را آپدیت می‌کنیم
    useEffect(() => {
        setValue('note', props.userNote || '')
    }, [props.userNote, setValue])
    
    const onSubmitHandler = (data) => {
        console.log(data);
    }
    
    return (
        <div className={Style.NoteHolder}>
            <p><span>*</span>توضيحاتی برای سفارش</p>
            <form onSubmit={handleSubmit(onSubmitHandler)} className={Style.NoteTextAreaHolder}>
                <Input 
                    {...register('note', {
                        required: false,
                        onChange: (e) => props.Textfunction(e.target.value) 
                    })} 
                    inputtype='Note' 
                    type='textarea'
                    placeholder='مثال: قارچ در ساندويج برگر مخصوص نريزيد' 
                />
            </form>
        </div>
    )
}

export default AddNote